import { CoreModal, CoreModalDescription } from "../../core";
import { useMobileLayout } from "../../hooks";
import i18nPackage from "../../i18n/i18n";

type UnsavedChangesModalProps = {
	onClose: () => void;
	onConfirm: () => void;
	inLms?: boolean;
};

export default function UnsavedChangesModal({ onClose, onConfirm, inLms }: UnsavedChangesModalProps) {
	const isMobileLayout = useMobileLayout();

	return (
		<CoreModal
			title={i18nPackage.t("editQuizPage.unsavedChanges.title")}
			open
			minWidth={!isMobileLayout ? "min(500px, 80%)" : undefined}
			maxWidth={isMobileLayout ? "95%" : "500px"}
			maxHeight="min(640px, 80%)"
			onClose={onClose}
			equalButtons
			footerVerticalPadding={"10px"}
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.unsavedChanges.cancelButton"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18nPackage.t("editQuizPage.unsavedChanges.leaveButton"),
					onClick: onConfirm,
				},
			]}
		>
			<CoreModalDescription>
				{inLms
					? i18nPackage.t("editQuizPage.unsavedChanges.lmsDescription")
					: i18nPackage.t("editQuizPage.unsavedChanges.ltiDescription")}
			</CoreModalDescription>
		</CoreModal>
	);
}
